import React from 'react'
import { useNavigate } from 'react-router-dom';
export default function TopLogo() {
    let navigate=useNavigate()
    const img = require("../IMAGES/logo1.png");
    return (
        <div onClick={()=>navigate('/')} className='cname'>
            <div>
                <img className='logo' src={img} alt="" /> 
            </div>
            <div className='company-name'>
                <h3>FLYXAVI</h3>
                <h5>AVIATION SERVICES</h5>
            </div>
        </div>    
    )
}
